<template>
    <div class="col-lg-9">
        <small class="text-muted text-muted mb-2">
            <router-link
                :to="`/business/dashboard`"
                class="font-weight-500 mr-2"
            >
                <i class="fas fa-home"></i>
            </router-link>

            <i class="fas fa-chevron-right mr-2"></i>
            <router-link
                :to="`/business/stored-accounts`"
                class="font-weight-500 mr-2"
            >
                Groups
            </router-link>
            <i class="fas fa-chevron-right mr-2"></i>
            <router-link
                :to="`/business/stored-accounts/${groupId}/group`"
                class="font-weight-500 mr-2"
            >
                Group - {{ groupName }}
            </router-link>
            <i class="fas fa-chevron-right mr-2"></i>
            Batch - {{ displayBatchName }}
        </small>
        <div class="mb-3"></div>
        <div class="d-flex align-items-center mb-4">
            <h4 class="text-7 mb-0 flex-grow-1 d-inline-block position-relative">
                <span class="position-relative d-inline-block d-flex align-items-center">

                    <span class="d-flex flex-column">
                        <span class="d-flex flex-row">
                            <span v-if="!isEditingBatchName">{{ form.batch_name }}</span>
                             <button v-if="!isEditingBatchName" @click="enableEditBatchName" class="btn btn-sm btn-link text-muted p-0 ml-2">
                                <i class="fas fa-edit"></i> <small>Edit</small>
                            </button>
                        </span>
                        <span class="d-flex flex-row">
                             <input
                                 v-if="isEditingBatchName"
                                 type="text"
                                 v-model="editedBatchName"
                                 class="form-control form-control-sm edit-input mr-2"
                                 placeholder="Enter batch name"
                             />

                            <button v-if="isEditingBatchName" :disabled="!editedBatchName" @click="saveBatchName" class="btn btn-sm btn-link p-0 ml-2">
                                <i class="fas fa-save"></i>
                            </button>
                             <button v-if="isEditingBatchName" @click="disableEditBatchName" class="btn btn-sm btn-link text-success p-0 ml-2">
                                <i class="fas fa-times-circle"></i>
                            </button>
                        </span>
                        <span v-if="form.errors.get('batch_name')" class="invalid-feedback d-block text-1">
                            {{ form.errors.get('batch_name') }}
                         </span>
                    </span>

                </span>
            </h4>

            <div class="button-group">
                <router-link
                    :to="`/business/stored-accounts/add`"
                    class="btn btn-primary btn-sm text-white shadow-none"
                >
                    <i class="fas fa-plus-circle mr-2"></i>Add Account
                </router-link>
            </div>
        </div>
        <ErrorAlert :message="message" :error="error" />
        <hr>
        <p class="d-flex flex-row align-items-center">
            <span>
                 <i class="fas fa-info-circle mr-2"></i>
            </span>
            <span>
                 Stored accounts allow businesses to manage frequently used account details for quick access and transactions.
            </span>
        </p>
        <hr>
        <div>
            <form @submit.prevent="data.fetch()" class="row my-4 align-items-center pr-3">
                <div class="col-lg-2">
                    <select @change="data.fetch()" v-model="data.filters.size" class="custom-select" required>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>

                <div class="input-group col-lg-4 ml-auto">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-white"><i class="fas fa-search"></i></span>
                    </div>
                    <input type="text" class="form-control" v-model="data.filters.search" placeholder="Search">
                </div>

                <button @click.prevent="data.fetch()"
                        :class="['btn btn-primary btn-sm text-white px-3 shadow-none', data.loading ? 'btn-loading' : '']">
                    <i class="fas fa-arrow-alt-circle-right"></i>
                </button>

            </form>

            <!-- Stored Accounts Table -->
            <div class="bg-light shadow-sm rounded py-4 mb-4">
                <div class="d-flex justify-content-start align-items-center mb-4 px-4">
                    <div class="mb-0">
                        <h3 class="text-4 font-weight-700 mb-0">
                            Stored Accounts
                        </h3>
                    </div>
                </div>
                <!-- Title =============================== -->
                <div class="transaction-title py-2 px-4">
                    <div class="row">
                        <div class="col-2 col-sm-2"><span class="">Type</span></div>
                        <div class="col col-sm-3 d-none d-sm-block ">Account</div>
                        <div class="col col-sm-3 d-none d-sm-block ">Account Number</div>
                        <div class="col-auto col-sm-4 text-center">Actions</div>
                    </div>
                </div>
                <!-- Title End -->

                <!-- Transaction List
                =============================== -->
                <div class="transaction-list">
                    <div v-if="data.content.data.length === 0" class="p-4">
                        <div class="table-responsive">
                            <div class="col-sm-12 col-md-12">
                                <div class="hover-border hover-section text-center px-3 py-4">
                                    <span class="d-block text-10 text-light mt-2 mb-3">
                                        <i class="fas fa-briefcase service-icon"></i>
                                    </span>
                                    <p class="mb-0 text-3 service-text">
                                        <b>You do not have any Stored Accounts </b>
                                    </p>
                                    <div class="mt-3">
                                        <router-link
                                            :to="`/business/stored-accounts/add`"
                                            class="btn btn-primary btn-sm text-white shadow-none ml-auto"
                                        >
                                            <i class="fas fa-plus-circle mr-2"></i>Add Account
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else v-for="row in data.content.data" :key="row.id" class="transaction-item d-block px-4 py-3">
                        <div class="row align-items-center flex-row">
                            <div class="col col-sm-2">
                                <span class="row-text">{{ row.account_type }}</span>
                            </div>
                            <div class="col col-sm-3 d-none d-sm-block">
                                <span class="row-text">{{ row.account_name }}</span>
                            </div>
                            <div class="col col-sm-3">
                                <span class="">{{ row.account_number }}</span>
                            </div>
                            <div class="col col-sm-4 d-flex justify-content-end">
                                <router-link :to="`/business/transact/form/${encodeURIComponent(row.account_name)}/${encodeURIComponent(row.group_name)}/${row.account_type}/${row.account_number}/${encodeURIComponent(row.contact_info)}`"
                                             class="btn btn-primary btn-sm btn-extra-small mr-2"
                                             v-if="row.account_type === 'ZESA'"
                                >
                                    <i class="fas fa-bolt"></i> Recharge
                                </router-link>

                                <router-link
                                    :to="`/business/stored-accounts/${row.id}/edit`"
                                    class="btn btn-outline-success btn-sm btn-extra-small mr-2">
                                    <i class="fas fa-edit"></i> Change
                                </router-link>

                                <button @click="confirmDelete(row)"
                                        class="btn btn-danger btn-sm btn-extra-small">
                                    <i class="fas fa-trash-alt"></i> Delete
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- Transaction List End -->

                <!-- Pagination ============================================= -->
                <div class="d-flex align-items-center justify-content-between px-4">
                <span class="text-black-50">
                    Showing {{ data.content.data.length }} of {{ data.content.total }} Records
                </span>
                    <ul class="pagination justify-content-center mt-4 mb-0">
                        <li class="page-item disabled">
                            <a class="page-link" href="#" tabindex="-1">
                                <i class="fas fa-angle-left"></i>
                            </a>
                        </li>
                        <li class="page-item active">
                            <a @click="data.append()"
                               v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                               class="page-link" href="#">
                                Load More <span class="sr-only">(current)</span>
                            </a>
                        </li>
                        <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                            <span>...</span>
                        </li>
                        <li class="page-item disabled">
                            <a class="page-link" href="#" tabindex="-1">
                                <i class="fas fa-angle-right"></i>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- Paginations end -->
            </div>
        </div>
    </div>
</template>

<script>
import Data from "../../../core/data/Data";
import Form from "../../../core/forms/form";
import ErrorAlert from "../components/ErrorAlert.vue";

export default {
    name: "Index",
    components: {ErrorAlert},
    data() {
        return {
            data: new Data({
                url: `/business/business-stored-accounts/batches/${this.$route.params.id}/accounts/list`,
                prefix: "list"
            }),
            form: new Form({
                batch_name: '',
            }),
            showModal: false,
            selectedAccount: {},
            groupName: "",
            displayBatchName: "",
            groupId: null,
            editedBatchName: "",
            isEditingBatchName: false,
            message: '',
            error:false
        };
    },
    methods: {

        fetchBatchName() {
            axios.get(`/business/business-stored-accounts/batches/${this.$route.params.id}`)
                .then(response => {
                    this.form.batch_name = response.data.body.batch.batch_name;
                    this.displayBatchName = response.data.body.batch.batch_name;
                    this.groupName = response.data.body.batch.group_name;
                    this.groupId = response.data.body.batch.group_id;
                })
                .catch(() => {
                    this.error = true;
                    this.message = "Error fetching batch name";
                });
        },

        enableEditBatchName() {
            this.editedBatchName = this.form.batch_name;
            this.isEditingBatchName = true;
        },

        disableEditBatchName() {
            this.editedBatchName = this.form.batch_name;
            this.isEditingBatchName = false;
        },
        saveBatchName() {
            this.form.fill('batch_name', this.editedBatchName);

            this.form.submit(`/business/business-stored-accounts/batches/${this.$route.params.id}/update`)
                .then(response => {
                    this.fetchBatchName();
                    this.isEditingBatchName = false;
                    this.$toast.success("Batch name updated successfully!", {
                        timeout: 3000
                    });
                })
                .catch(error => {
                    this.$toast.error("Error updating batch name. Please try again.", {
                        timeout: 3000
                    });
                });
        },

        confirmDelete(account) {
            let confirmationMessage = `Are you sure you want to delete stored account "${account.account_name}"?`;
            window.alerts.confirm(confirmationMessage).then((confirmed) => {
                if (confirmed) {
                    this.deleteAccount(account);
                }
            });
        },

        deleteAccount(account) {
            axios.delete(`/business/business-stored-accounts/${account.id}`)
                .then(response => {
                    window.alerts.success(response).then(() => {
                        this.data.fetch();
                    });
                })
                .catch(error => {
                    window.alerts.error(error.response);
                });
        },
    },
    mounted() {
        this.data.fetch()
        this.fetchBatchName()
    }
}
</script>

<style scoped>
.row-text{
    color: #252c65;
}
.btn-extra-small {
    padding: 6px 6px;
    font-size: 12px;
    line-height: 1.2;
}
.button-group {
    display: flex;
    gap: 8px;
    margin-left: auto;
}
.row-text{
    color: #252c65;
}
.btn-extra-small {
    padding: 6px 6px;
    font-size: 12px;
    line-height: 1.2;
}
.d-flex {
    transition: all 0.3s ease;
}

.form-control-sm {
    border-radius: 4px;
    border: 1px solid #ddd;
    padding: 6px 12px;
    font-size: 14px;
}
.btn-success:hover {
    background-color: #28a745;
    border-color: #28a745;
}

.edit-input {
    width: 70%;
    min-width: 200px;
    max-width: 300px;
}
</style>
